export default __webpack_public_path__ + "static/media/self_study_reg.492c6961.png";